import { Inputfiledsbase } from './models/inputfiledsbase';

export class DatepickerQuestion extends Inputfiledsbase<string> {
  override controlType = 'datepicker';
}